import React, { useEffect } from 'react';
import {
    useGetKunderQuery,
    useGetReportMappingQuery,
} from '@klp/reportMapping/api/rtkApi';
import { MappingForm } from './MappingForm';
import { LocalLoader } from '@klp/design/Loader';
import type { ReportWithMappingDto } from '@klp/reportMapping/types';
import { getInitialValues } from './helpers';
import { useGetByggListQuery } from '@klp/contextSelector/services/rtkApi';

type MappingDataLayerProps = {
    reportId: string;
    preLoadData: ReportWithMappingDto;
    onClose: () => void;
};

export const MappingDataLayer = ({
    reportId,
    preLoadData,
    onClose,
}: MappingDataLayerProps) => {
    const { currentData, isSuccess, isFetching, isError } =
        useGetReportMappingQuery(
            { reportId },
            { refetchOnMountOrArgChange: true },
        );
    const { data: byggList = [], isLoading: byggLoading } = useGetByggListQuery(
        { includeAll: true },
    );
    const { data: kundeList = [], isLoading: kundeLoading } = useGetKunderQuery(
        { navnOrNummer: '' },
    );

    const initialValues = getInitialValues(currentData ?? preLoadData);
    const splitByggNummer = initialValues.byggNummer.split(',');
    const initialByggOption = byggList.filter((bygg) =>
        splitByggNummer.includes(bygg.nummer ?? ''),
    );
    const initialKundeOption =
        kundeList.find((kunde) => kunde.nummer === initialValues.kundenummer) ??
        null;

    const isLoading = !isSuccess || isFetching || kundeLoading || byggLoading;

    useEffect(() => {
        if (isError) {
            onClose();
        }
    }, [isError, onClose]);

    return (
        <LocalLoader isLoading={isLoading}>
            <MappingForm
                key={initialValues.byggNummer + initialValues.kundenummer}
                reportData={currentData ?? preLoadData}
                onClose={onClose}
                initialByggOption={initialByggOption}
                initialKundeOption={initialKundeOption}
            />
        </LocalLoader>
    );
};
